import RbataLogger from '../utils/rbata.logger';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import productTileSwatches from '../plp/rbata.tileSwatches';
import productTileSlider from '../plp/rbata.tileSlider';
import {Bloomreach} from '../utils/bloomreach';
import {ProductTemplating} from '../utils/rbata.productTemplating';
import trackingProductTile from '../tracking/rbata.product-tile';
import MerchandisingCarousel from './rbata.merchandisingCarousel';

// Supports multiple recommendation components on a page
export const productRecommendations = {
    $container:       undefined,
    bloomreachIds:    {},
    componentConfigs: {},
    currentProduct:   undefined,
    productResponse:  {},
    fakeBg:           'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',

    init() {
        this.$container = $('.js-brRecommendation'); // Can be multiple on page
        this.currentProduct = window.location.href.match(/\/(ATA\d+)\//)?.[1];
    },

    recommendationsCallback(response) {
        if (!response?.length) {
            RbataLogger.debug('Bloomreach did not return any result');
            return;
        }

        const recommendationId = response[0].recommendation_id;
        productRecommendations.bloomreachIds[recommendationId] = response?.map(item => item.product_id ?? '');
        productRecommendations.fetchProductData();
    },

    load() {
        this.$container.each((_, container) => {
            const containerData = $(container).data('config');
            this.componentConfigs = {...this.componentConfigs, ...{[containerData.recommendationId]: containerData}};
        });

        RbataLogger.debug(`Found [${Object.keys(this.componentConfigs).length}] recommendation element(s).`)

        Object.keys(this.componentConfigs).forEach((configKey, index) => {
            const config = this.componentConfigs[configKey];
            try {
                Bloomreach.fetchPersonalizedProducts(config, [this.currentProduct], this.recommendationsCallback);
                RbataLogger.debug(`Loading recommendation [${index}]:`, config.recommendationId);
            } catch (exception) {
                RbataLogger.debug(`Error fetching recommendations: [${config.recommendationId}]`, exception.message)
            }
        });
    },

    renderProducts() {
        Object.keys(this.productResponse).forEach(recommendationId => {
            let productsTemplate = '';
            const currentRecommendationSlider = this.$container.find(`#br-${recommendationId}`);
            this.productResponse[recommendationId].forEach((product, index) => {
                productsTemplate += ProductTemplating.productTemplate(product, index, this.componentConfigs?.[recommendationId]?.compUid);
            });
            currentRecommendationSlider.append(productsTemplate);

            // Reload visual elements and reveal container
            mediaLazyLoad.refreshLazyLoad();
            productTileSwatches.reInit();
            productTileSlider.reInit();
            currentRecommendationSlider.parents('.js-brRecommendation').removeClass('d-none');

            // Make a carousel
            MerchandisingCarousel.bindHandler();

            // Start tracking
            this.trackingTilesView(currentRecommendationSlider);
            this.trackingTilesOnClick(currentRecommendationSlider);

            RbataLogger.debug(`Render recommendation [${recommendationId}] - SUCCESS`);
        });
    },

    fetchProductData() {
        Object.keys(productRecommendations.bloomreachIds).forEach(recommendationId => {
            const config = this.componentConfigs[recommendationId];
            const productIds = this.bloomreachIds[recommendationId].length ? this.bloomreachIds[recommendationId].join(',') : [];
            const url = Bloomreach.getRecommendationsUrl(config.compUid, productIds);
            let request = $.ajax({
                url: url, method: 'POST', cache: false
            });

            request.done((data) => {
                if (data.products && data.products.length) {
                    RbataLogger.debug(`Fetch success for recommendation [${recommendationId}]. Rendering...`);
                    this.productResponse = {[recommendationId]: data.products};
                    this.renderProducts();
                }
            });

            request.fail(() => {
                RbataLogger.debug(`Fetch Failed for recommendation [${recommendationId}]`)
            });
        });
    },

    trackingTilesView($slider) {
        const sliderProducts = $slider.find('.js-tile-track');

        const carouselTileIntersectionHandler = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    trackingProductTile.trackProductImpression(entry.target.dataset);
                    observer.unobserve(entry.target)
                }
            });
        }

        const intersectionOptions = {
            root:       null,
            rootMargin: '0px',
            threshold:  [0.25]
        };

        const observer = new IntersectionObserver(carouselTileIntersectionHandler, intersectionOptions);

        if (sliderProducts) {
            for (const slide of sliderProducts) {
                observer.observe(slide);
            }
        }
    },

    trackingTilesOnClick($slider) {
        $slider.on('click', '.js-tile-track', event => {
            trackingProductTile.trackProductClick(event.currentTarget.dataset);
        });
    }
}